module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"input":{"search_placeholder":"Start typing to search","works_label":"Works"},"no_data":"Sorry, but nothing matching was found"},"cs":{"input":{"search_placeholder":"Pro vyhledávání začněte psát","works_label":"Díla"},"no_data":"Je nám to líto, ale nic odpovídajícího jsme nenašli"}}')
  delete Component.options._Ctor
}
